<template>
  <v-card class="d-flex flex-column" outlined>
    <StockMidBulkFile />
    <StockMidBulkHistory />
  </v-card>
</template>

<script>
export default {
  name: 'StockMidBulk',
  components: {
    StockMidBulkHistory: () =>
      import('./stock-mid-bulk/StockMidBulkHistory.vue'),
    StockMidBulkFile: () => import('./stock-mid-bulk/StockMidBulkFile.vue'),
  },
};
</script>
